export const VIDEO_START_TIME = 0; // seconds

export const seekTo = async (video: HTMLVideoElement, t: number) => {
  if (video.readyState < 1) {
    await new Promise<void>(res =>
      video.addEventListener('loadedmetadata', () => res(), { once: true })
    );
  }
  const target = Math.min(t, Math.max(0, (video.duration || t + 0.1) - 0.1));
  video.currentTime = target;
};
